import React, { Component } from 'react';
import { find } from 'lodash';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import moment from 'moment';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { pdf } from '@react-pdf/renderer';
import { WithStyles, withStyles } from '@mui/styles';
import APCurrencyIcon from '../../components/atoms/APCurrencyIcon';

import APDropDownMenu from '../../components/atoms/APDropDownMenu';
import APSection from './../../components/atoms/APSection';
import APSegmentedControl from './../../components/atoms/APSegmentedControl';
import APSelectDropdown from '../../components/atoms/APSelectDropdown';
import APSeriesTable from './../../components/organisms/APSeriesTable';
import APStatistic from './../../components/atoms/APStatistic';
import PDFSeriesTable from './../../components/organisms/APSeriesTable/utils/pdf';
import { actions as CommissionsActions } from './../../redux/modules/commissions';
import { generate as xlsx } from './../../components/organisms/APSeriesTable/utils/xlsx';
import { ReducerState } from '../../redux/modules';
import { withTranslate, withTenant } from '../../core/TenantProvider';
import APCommissionsSection from './../../components/organisms/APCommissionsSection';
import CommissionsContainerStyles from './styles/CommissionsContainer.style';
import { CircularProgress } from '@mui/material';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import {
	COMMISSIONS_SUMMARY_VIEW,
	COMMISSIONS_DETAILED_VIEW,
	DEFAULT_COMMISSIONS_BREAKPOINT,
	DEFAULT_COMMISSIONS_DETAILED_BREAKPOINT,
	PDF_DOCUMENT_TYPE,
	XLSX_DOCUMENT_TYPE,
	TOTAL_COMMISSION_AMOUNT_PAID,
	TOTAL_COMMISSION_PAID_CURRENCY,
	TOTAL_COMMISSION_AMOUNT,
	TOTAL_COMMISSION_CURRENCY,
	TIER_AMOUNT_CURRENCY,
	TIER_AMOUNT_KEYS,
	LEGAL_ENTITY_SHORT_HAND
} from '../../core/utils/Constants/Constants';
import { PdfSaveAs } from '../../core/utils/PDFGenerate';
import APBackdropLoader from '../../components/atoms/APBackdropLoader';
import { GetAllAffiliateDetails } from '../../core/utils/Affiliates';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import { SortAffiliates } from '../../core/utils/SortAffiliates';
import { GetCurrencySymbol } from '../../core/utils/GetCurrenciesData';
import GetDropdownFormat from '../../core/utils/GetDropdownFormat';
import { CommissionStatementMetadata } from '../../core/types/GenrateMonthStatements';
import { CommissionViewType } from '../../core/types/Series';

const FILTER_OPTIONS = [
	{ label: 'commissions.tiers.first.label', value: 1 },
	{ label: 'commissions.tiers.second.label', value: 2 },
	{ label: 'commissions.tiers.third.label', value: 3 }
];

interface CommissionsContainerProps extends WithStyles<typeof CommissionsContainerStyles> {
	details: any,
	getCommissionsDetails: Function,
	getCommissionsSummary: Function,
	commissionsDataReset: Function,
	results: any,
	settings: any,
	translate: any,
	affiliateDetails: any,
	loadingState: string
}

class CommissionsContainer extends Component<CommissionsContainerProps, {}> {
	state = {
		statement: null,
		statementInputValue: null,
		tier: 1,
		view: 'generated',
		commissionsViewType: COMMISSIONS_SUMMARY_VIEW,
		isGroupAffiliate: false,
		allAffiliatesData: [],
		allAffiliatesNumbers: [],
		selectedAffiliate: '',
		breakpoint: DEFAULT_COMMISSIONS_BREAKPOINT,
		disabled: true,
		isLoading: false
	};

	constructor(props: CommissionsContainerProps) {
		super(props);

		this.onChangeStatement = this.onChangeStatement.bind(this);
		this.onChangeTier = this.onChangeTier.bind(this);
		this.onChangeView = this.onChangeView.bind(this);
		this.onDownload = this.onDownload.bind(this);
		this.onChangeOfAffiliate = this.onChangeOfAffiliate.bind(this);
		this.refresh = this.refresh.bind(this);
		this.updateStatementCommissionDetails = this.updateStatementCommissionDetails.bind(this);
		this.fetchCommissionsDetails = this.fetchCommissionsDetails.bind(this);
	}

	componentDidMount() {
		const {
			getCommissionsSummary,
			affiliateDetails,
			translate
		} = this.props;

		const {
			isGroupAffiliate,
			allAffiliatesData,
			allAffiliatesNumbers,
		} = GetAllAffiliateDetails(affiliateDetails, translate);

		const selectedAffiliate = isGroupAffiliate ? allAffiliatesNumbers[0] : affiliateDetails?.affiliate?.affiliate_Number;

		getCommissionsSummary(getCurrentAffiliateIds(allAffiliatesNumbers, selectedAffiliate)).then((response: any) => {
			if (response.statements) {
				this.refresh(response.statements, getCurrentAffiliateIds(allAffiliatesNumbers, selectedAffiliate), 0);
			}
		}).catch((error: any) => console.error('Error:', error));

		let resizeTimer: ReturnType<typeof setTimeout>;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this.refreshTableBreakpoint(this.state.commissionsViewType);
			}, 500);
		});

		this.setState({
			isGroupAffiliate,
			allAffiliatesData,
			allAffiliatesNumbers,
			selectedAffiliate
		})
	}

	onChangeStatement(evt: any) {
		const {
			target: {
				value
			}
		} = evt;
		TriggerGoogleAnalyticsTag(
			GoogleAnalyticTags.eventAction.select,
			GoogleAnalyticTags.commissions.select.filterMonth,
			{ filterMonth: value }
		);
		TriggerGoogleAnalytics4Tag(
			GoogleAnalytics4Tags.commissions.name,
			GoogleAnalytics4Tags.eventAction.select,
			GoogleAnalytics4Tags.commissions.select.filterMonth,
			{ filterMonth: value }
		);
		const {
			allAffiliatesNumbers,
			selectedAffiliate
		} = this.state;

		this.refresh(this.props.results.statements, getCurrentAffiliateIds(allAffiliatesNumbers, selectedAffiliate), value, true);
	}

	onChangeTier(tier: any) {
		this.setState({
			tier
		});
		switch (tier) {
			case 1:
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.click,
					GoogleAnalyticTags.commissions.click.firstTier
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.commissions.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.commissions.click.firstTier
				);
				break;
			case 2:
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.click,
					GoogleAnalyticTags.commissions.click.secondTier
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.commissions.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.commissions.click.secondTier
				);
				break;
			case 3:
				TriggerGoogleAnalyticsTag(
					GoogleAnalyticTags.eventAction.click,
					GoogleAnalyticTags.commissions.click.thirdTier
				);
				TriggerGoogleAnalytics4Tag(
					GoogleAnalytics4Tags.commissions.name,
					GoogleAnalytics4Tags.eventAction.click,
					GoogleAnalytics4Tags.commissions.click.thirdTier
				);
				break;
		}
	}

	onChangeView(evt: any) {
		const {
			target: {
				name,
				value
			}
		} = evt;

		this.setState({
			[name]: value
		});
	}

	getGroupsByTier(details, translate) {
		return {
			'tier1': {
				series: details.events.filter((item: any) => item.event.tier === 1),
				title: translate && translate('commissions.tiers.first.label')
			},
			'tier2': {
				series: details.events.filter((item: any) => item.event.tier === 2),
				title: translate && translate('commissions.tiers.second.label')
			},
			'tier3': {
				series: details.events.filter((item: any) => item.event.tier === 3),
				title: translate && translate('commissions.tiers.third.label')
			}
		}
	}

	onDownload = async (type: string) => {
		const {
			affiliateDetails,
			details,
			translate,
			settings
		} = this.props;
		this.setState({ isLoading: true });
		let statementMonth: string = '';
		if (this.state.statement) {
			const statement: any = this.state.statement;
			const period = moment();
			period.date(1);
			period.month(statement.statementmonth - 1);
			period.year(statement.statementyear);
			statementMonth = period.format('MMMM YYYY');
			if (statement.statementnumber > 1) {
				statementMonth = `${statementMonth} (${statement.statementnumber})`;
			}
		}

		let affiliateName: string = affiliateDetails?.affiliate?.company_name;
		let groups: any;

		if (details && details.events) {
			groups = this.getGroupsByTier(details, translate);
		}

		TriggerGoogleAnalyticsTag(
			GoogleAnalyticTags.eventAction.click,
			GoogleAnalyticTags.commissions.click.downloadLink
		);
		TriggerGoogleAnalytics4Tag(
			GoogleAnalytics4Tags.commissions.name,
			GoogleAnalytics4Tags.eventAction.click,
			GoogleAnalytics4Tags.commissions.click.downloadLink
		);

		if (type === XLSX_DOCUMENT_TYPE) {

			if (this.state.commissionsViewType === COMMISSIONS_DETAILED_VIEW) {
				xlsx(groups, 'Commissions statement.xlsx', true, translate, affiliateName, 'commissionsView', details.summary, statementMonth);
			} else {
				xlsx(this.props.details.events, 'Commissions statement.xlsx', false, translate, affiliateName, 'commissionsView', details.summary, statementMonth);
			}
			this.setState({ isLoading: false });
		}

		if (type === PDF_DOCUMENT_TYPE) {

			const commissionsViewType = this.state.commissionsViewType,
				isDetailedCommissionsViewType: boolean = (commissionsViewType === 'Detailed');

			const PdfDocument = this.PDF({ settings, translate, affiliateDetails, details, isDetailedCommissionsViewType, groups, commissionsViewType, statementMonth });
			if (!PdfDocument) { return; }
			const blob = pdf((
				PdfDocument
			));
			if (blob) {
				blob.updateContainer(PdfDocument);
				setTimeout(async () => {
					const result = await blob.toBlob();
					this.setState({ isLoading: false });
					const fileName = "commissions-pdf.pdf";

					PdfSaveAs(result, fileName);
				}, 1000);
			}
		}
	}

	PDF = ({ settings, translate, affiliateDetails, details, isDetailedCommissionsViewType, groups, commissionsViewType, statementMonth }) => (
		<PDFSeriesTable
			org={settings.ORG_CODE}
			logo={settings.LOGO_PNG}
			groups={(isDetailedCommissionsViewType && groups)}
			series={!isDetailedCommissionsViewType && details.events}
			title={translate('commissions.section.annualsummary.title')}
			translate={translate}
			affiliateData={affiliateDetails?.affiliate}
			statementMonth={statementMonth}
			commissionDetails={details.summary}
			viewType={commissionsViewType}
		/>
	);


	onChangeOfAffiliate(evt: any) {
		const {
			target: {
				value
			}
		} = evt;

		const {
			getCommissionsSummary,
			commissionsDataReset,
		} = this.props;

		this.setState({
			selectedAffiliate: value
		}, () => {

			const currentAffiliateNumbers = getCurrentAffiliateIds(this.state.allAffiliatesNumbers, this.state.selectedAffiliate);
			getCommissionsSummary(currentAffiliateNumbers).then((response: any) => {
				if (response.statements?.length > 0) {
					this.refresh(response.statements, currentAffiliateNumbers, 0);
				} else {
					commissionsDataReset();
				}
			}).catch((error: any) => console.error('Error:', error));
		});
	}

	updateTierBasedOnCounts(response: any) {
		let groups: any,
			tierOneCount: number,
			tierTwoCount: number,
			tierThreeCount: number;

		if (response.events) {
			groups = this.getGroupsByTier(response, false);
		}

		// Count records after month changed
		tierOneCount = groups.tier1.series.length;
		tierTwoCount = groups.tier2.series.length;
		tierThreeCount = groups.tier3.series.length;

		if (tierOneCount > 0) {
			this.setState({ tier: 1 });
		} else if (tierTwoCount > 0) {
			this.setState({ tier: 2 })
		} else if (tierThreeCount > 0) {
			this.setState({ tier: 3 })
		}
	}

	fetchCommissionsDetails(affiliateNumbers: Array<string>, commissionsViewType: any, isChanged?: boolean) {
		const {
			getCommissionsDetails,
			translate
		} = this.props
		getCommissionsDetails(affiliateNumbers, this.state.statement, commissionsViewType, translate)
			.then((response) => {
				if (response.events && isChanged && commissionsViewType === COMMISSIONS_DETAILED_VIEW) {
					this.updateTierBasedOnCounts(response);
				}
			});

		this.refreshTableBreakpoint(commissionsViewType);
	}

	updateStatementCommissionDetails(statements: CommissionStatementMetadata[] | [], affiliateNumbers: Array<string>, index: number, isChanged?: boolean) {
		const {
			affiliateDetails
		} = this.props;

		const commissionsViewType: CommissionViewType = affiliateDetails?.affiliate?.commission_view ?
			affiliateDetails?.affiliate?.commission_view : COMMISSIONS_SUMMARY_VIEW;

		this.setState({
			statement: statements[index],
			statementInputValue: index,
			commissionsViewType
		},
			() => {
				if (this.state.statement) {
					this.fetchCommissionsDetails(affiliateNumbers, commissionsViewType, isChanged);
				}
			}
		);
	}

	refresh(statements: CommissionStatementMetadata[] | [], affiliateNumbers: Array<string>, index?: number, isChanged?: boolean) {
		if (index === undefined) {
			this.setState({
				statementInputValue: undefined
			});
			return;
		}

		this.setState({ disabled: !statements });
		this.updateStatementCommissionDetails(statements, affiliateNumbers, index, isChanged);
	}

	refreshTableBreakpoint(commissionsViewType: string = COMMISSIONS_SUMMARY_VIEW) {
		const { tier } = this.state;
		let breakpoint: number;

		switch (tier) {
			case 1:
				breakpoint = (commissionsViewType === COMMISSIONS_DETAILED_VIEW) ? DEFAULT_COMMISSIONS_DETAILED_BREAKPOINT : DEFAULT_COMMISSIONS_BREAKPOINT;
				break;

			case 2:
				breakpoint = (commissionsViewType === COMMISSIONS_DETAILED_VIEW) ? DEFAULT_COMMISSIONS_DETAILED_BREAKPOINT : DEFAULT_COMMISSIONS_BREAKPOINT;
				break;

			case 3:
				breakpoint = (commissionsViewType === COMMISSIONS_DETAILED_VIEW) ? DEFAULT_COMMISSIONS_DETAILED_BREAKPOINT : DEFAULT_COMMISSIONS_BREAKPOINT;
				break;

			default:
				breakpoint = DEFAULT_COMMISSIONS_BREAKPOINT;
		}

		this.setState({
			breakpoint
		})
	}

	componentDidUpdate(prevProps: Readonly<CommissionsContainerProps>, prevState: Readonly<{}>, snapshot?: any): void {
		const {
			affiliateDetails,
			getCommissionsDetails,
			translate
		} = this.props;

		const groupAffiliates = affiliateDetails?.GroupData?.length > 0 ? affiliateDetails.GroupData : [],
			isGroupAffiliate = groupAffiliates.length > 0;

		if (affiliateDetails?.affiliate?.commission_view && affiliateDetails?.affiliate?.commission_view !== this.state.commissionsViewType &&
			this.state.isGroupAffiliate !== isGroupAffiliate) {

			const commissionsViewType = affiliateDetails.affiliate?.commission_view;
			const allAffiliatesData = isGroupAffiliate ? getAllAffiliatesData(affiliateDetails, groupAffiliates, translate) : [];


			const allAffiliatesNumbers = allAffiliatesData.reduce(function (affiliateIds, affiliate) {
				if (affiliate.affiliateNumber !== 'all') { // this serves as our `filter`
					affiliateIds.push(affiliate.affiliateNumber);
				}
				return affiliateIds;
			}, []);

			if (this.state.isGroupAffiliate !== isGroupAffiliate) {
				this.setState({
					isGroupAffiliate,
					allAffiliatesData,
					allAffiliatesNumbers
				})
			}

			this.setState({
				commissionsViewType
			}, () => {
				this.state.statement && getCommissionsDetails(allAffiliatesNumbers, this.state.statement, commissionsViewType, translate);
				this.refreshTableBreakpoint(this.state.commissionsViewType);
			});
		}
	}

	renderMiniStat(config: any) {
		const {
			classes,
			translate
		} = this.props;

		const {
			displayIcon = false,
			name,
			primary,
			secondary
		} = config;

		const summary = (
			<span className={classes.miniStatSummary}>
				<span className={classes.miniStatValue}>{secondary}</span>
				<span className={classes.miniStatLabel}>
					{translate(`commissions.ministat.${name}.summary`)}
				</span>
			</span>
		);

		let icon;
		if (displayIcon) {
			if (secondary > 0) {
				icon = <ArrowDropUpIcon className={classes.iconUp} />
			} else if (secondary < 0) {
				icon = <ArrowDropDownIcon className={classes.iconDown} />
			}
		}

		let label = translate(`commissions.ministat.${name}.name`);
		if (translate.has(`commissions.ministat.${name}.${this.state.view}.name`)) {
			label = translate(`commissions.ministat.${name}.${this.state.view}.name`);
		}

		return (
			<APStatistic
				icon={icon}
				mini
				name={label}
				summary={summary}
				value={primary}
			/>
		)
	}

	render() {
		const {
			classes,
			details,
			results,
			translate,
			affiliateDetails,
			loadingState
		} = this.props;

		const commissionsViewType = this.state.commissionsViewType;
		const isDetailedCommissionsViewType: boolean = (commissionsViewType === COMMISSIONS_DETAILED_VIEW);
		const summaryHeaderText: string = isDetailedCommissionsViewType ? translate('commissions.section.summary.header.transaction') :
			translate('commissions.section.summary.header.payment.breakdown');
		const dateColumnText: string = translate('commissions.section.detail.column.Date');

		let statementTitle: string = '';
		if (this.state.statement) {
			const statement: any = this.state.statement;

			const period = moment();
			period.date(1);
			period.month(statement.statementmonth - 1);
			period.year(statement.statementyear);

			const date: string = period.format('MMMM YYYY');
			const formattedDate: string = date.charAt(0).toUpperCase() + date.slice(1);

			statementTitle = formattedDate;
			
			if (statement.statementnumber > 1) {
				statementTitle = `${statementTitle} (${statement.statementnumber})`;
			}
		}

		let series = details && details.events;
		let tierLabel: string = '';
		if (isDetailedCommissionsViewType && series && this.state.tier) {
			series = series.filter((item: any) => item.event.tier === this.state.tier);

			const getTierLabel: any = find(FILTER_OPTIONS, { value: this.state.tier });
			tierLabel = getTierLabel.label;
		}

		let statements = [];
		if (results && results.statements) {
			statements = results.statements.map((value: CommissionStatementMetadata, index: number) => {
				const period = moment();
				period.date(1);
				period.month(value.statementmonth - 1);
				period.year(value.statementyear);

				const date: string = period.format('MMMM YYYY');
				const formattedDate = date.charAt(0).toUpperCase() + date.slice(1);

				const { legalentity, statementnumber } = value;
				let label = {
					firstSection: `${formattedDate}`,
					secondSection: `${LEGAL_ENTITY_SHORT_HAND[legalentity] || ''}`
				}
				if (statementnumber > 1) {
					label.secondSection = `${label.secondSection} (${statementnumber})`;
				}
				return {
					label,
					value: String(index)
				};
			});
		}

		const statementClass = (this.state.commissionsViewType === COMMISSIONS_DETAILED_VIEW) ? classes.statementDetail : classes.statementSummary;

		let allAffiliatesData: any;
		if (this.state.isGroupAffiliate && this.state.allAffiliatesData) {
			allAffiliatesData = GetDropdownFormat(this.state.allAffiliatesData);
			allAffiliatesData = allAffiliatesData.length > 1 ? SortAffiliates(allAffiliatesData) : allAffiliatesData;
		}

		let statementInputValue: any = this.state.statementInputValue;
		const isLoading = this.state.isLoading;
		return (
			<div>
				<div className={classes.commissionsContainer}>
					{(loadingState === 'LOADING' || loadingState === 'DETAILS_LOADING') ?
						(
							<div className={classes.graphLoader}>
								<CircularProgress className={classes.graphLoaderSpinner} />
							</div>
						) : (
							<div className={classes.commissionsContainerContent}>
								{(isLoading) ?
									<APBackdropLoader open={true} /> : ''
								}
								<APSection className={classes.commissionsSection}
									title={translate('commissions.section.commission.title')}
									dropdownData={allAffiliatesData}
									onDropdownChange={this.onChangeOfAffiliate}
									initialDropdownValue={this.state.selectedAffiliate}>
									<APCommissionsSection baseCurrency={affiliateDetails?.affiliate?.default_currency}
										selectedAffiliate={this.state.selectedAffiliate} />
								</APSection>


								{details && details.summary &&

									<APSection padded={false} title={translate('commissions.section.annualsummary.title')}>

										{series && series.length > 0 &&
											<APDropDownMenu
												className={classes.dropDownMenu}
												label={"Download"}
												onChange={this.onDownload}
												options={[
													{ label: 'PDF', value: 'pdf' },
													{ label: "XLSX", value: 'xlsx' }
												]}
												hasDownloadIcon={true}
											/>
										}

										{details && details.summary && (
											<div className={classes.statementHeader}>
												<div className={classes.statementTitle}>
													<div className={classes.statementTitleIntro}>
														<span className={classes.statementTitleText}>
															{translate('commissions.section.annualsummary.month.title')}
														</span>
														<span className={classes.statementTitleMonth}>
															{statementTitle}
														</span>
													</div>
													<APSelectDropdown
														disabled={this.state.disabled}
														value={statementInputValue}
														className={classes.statementSelection}
														data={statements}
														label={translate('commissions.section.summary.month.dropdown.label')}
														onChange={this.onChangeStatement}
														name="commissionStatementType"
													/>
												</div>
												<div className={statementClass}>
													{Object.keys(details.summary).map((key: string) => {
														if (key === TOTAL_COMMISSION_CURRENCY || key === TIER_AMOUNT_CURRENCY) {
															return null;
														}
														const isTotalCommissionAmountPaidKey: boolean = key === TOTAL_COMMISSION_AMOUNT_PAID;
														const isTotalCommissionAmountKey: boolean = key === TOTAL_COMMISSION_AMOUNT;
														const isTierAmountKey: boolean = TIER_AMOUNT_KEYS.includes(key);

														const isTotalCommissionPaidCurrencyKey: boolean = key === TOTAL_COMMISSION_PAID_CURRENCY;
														const paidCurrencyFlag: string | JSX.Element = isTotalCommissionPaidCurrencyKey ?
															<APCurrencyIcon currency={details.summary[TOTAL_COMMISSION_PAID_CURRENCY]} /> : '';

														const totalClass: string = isTotalCommissionAmountPaidKey ? classes.statementColumnValueLG : classes.statementColumnValue;
														const totalPaidCurr: string = isTotalCommissionAmountPaidKey ? details.summary[TOTAL_COMMISSION_PAID_CURRENCY] : '';
														const totalCommissionCurrency: string = isTotalCommissionAmountKey ? details.summary[TOTAL_COMMISSION_CURRENCY] : '';
														const tireCommissionCurrency: string = isTierAmountKey ? details.summary[TIER_AMOUNT_CURRENCY] : '';

														return (
															<div key={key} className={classes.statementColumn}>
																<span className={classes.statementColumnTitle}>
																	{translate(`commissions.section.detail.column.${key}`)}
																</span>
																<span className={totalClass}>
																	{paidCurrencyFlag}
																	{isTotalCommissionAmountPaidKey ? GetCurrencySymbol(totalPaidCurr) : totalPaidCurr}
																	{isTotalCommissionAmountKey ? GetCurrencySymbol(totalCommissionCurrency) : totalCommissionCurrency}
																	{isTierAmountKey ? GetCurrencySymbol(tireCommissionCurrency) : tireCommissionCurrency}
																	{details.summary[key]}
																</span>
															</div>
														)
													})}
												</div>
											</div>
										)}
									</APSection>
								}

								{isDetailedCommissionsViewType && details && details.events && (
									<APSegmentedControl
										onChange={this.onChangeTier}
										options={FILTER_OPTIONS.map(filter => ({
											...filter,
											label: translate(filter.label),
											disabled: !details.events.find((item: any) => item.event.tier === filter.value)
										}))}
										selection={this.state.tier}
									/>
								)}

								{series && (
									<APSeriesTable
										hideEvent={!isDetailedCommissionsViewType}
										summaryHeader={summaryHeaderText}
										summaryHeaderBrackets={isDetailedCommissionsViewType ? translate(tierLabel) : ''}
										dateColumnCopy={dateColumnText}
										colSpanCount={isDetailedCommissionsViewType ? 8 : 6}
										pagination={10}
										series={series}
										breakPoint={this.state.breakpoint}
										ignoredFields={['closed_date']}
									/>
								)}

							</div>
						)
					}

				</div>
			</div>
		);
	}
}

const getAllAffiliatesData = (affiliateDetails, groupAffiliates, translate) => {
	const allAffiliatesData = groupAffiliates.map((affiliate) => (
		{
			affiliateNumber: affiliate.affNumbers,
			affiliateName: affiliate.name,
			subAffiliate: affiliate.subAffiliate
		}
	));

	return [
		{
			affiliateNumber: affiliateDetails.affiliate.affiliate_Number,
			affiliateName: affiliateDetails.affiliate.company_name,
			subAffiliate: []
		},
		...allAffiliatesData
	];
};

const getCurrentAffiliateIds = (affiliateNumbers: Array<string>, selectedAffiliateValue: string) => {
	if (selectedAffiliateValue !== 'all' && selectedAffiliateValue?.length > 0) {
		return [selectedAffiliateValue];
	} else {
		return affiliateNumbers;
	}
};

const mapStateToProps = (state: ReducerState) => ({
	details: state.commissions.details,
	results: state.commissions.results,
	affiliateDetails: state.user.affiliateDetails,
	loadingState: state.commissions.loadingState
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	getCommissionsDetails: CommissionsActions.getCommissionsDetail,
	getCommissionsSummary: CommissionsActions.getCommissionsSummary,
	commissionsDataReset: CommissionsActions.commissionsDataReset,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
	withTenant(
		withTranslate(
			withStyles(CommissionsContainerStyles)(CommissionsContainer)
		)
	)
);
